import { View, Text, FlatList, Platform } from 'react-native'
import React, { FunctionComponent } from 'react'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'
import { PdfViewer } from '../../components/PdfViewer';
import { useResponsive } from '@hooks';
import { Dialog } from '../../components/Dialog';
import styles from './FicheSalaire.styles'
import { stdCouleurBleu } from '@commonStyle'
import { useFicheSalaireState,  } from './FicheSalaire.states'
import { InfoCentre } from '../../components/InfoCentre/InfoCentre.component';
import BulletinItem from './BulletinItem';
import useEnTetePage from '../../components/EnTetePage/EnTetePage';
import dayjs from 'dayjs';

const isWeb = Platform.OS === 'web';

export const getMonthNumber = (monthName: number): string => {
  const months = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ]
  return months[monthName - 1] || 'Janvier'
}

export const FicheSalaire: FunctionComponent = () => {
  const { EnTete, currentDate } = useEnTetePage({
    text: "Bulletins de paie",
    periodGestion: {
      period: 'year',
      defaultDate: dayjs()
    }
  });
  const {
    selectedBulletin,
    showPdfViewer,
    bulletinsPaie,
    loading,
    error,
    pdfKey,
    handleBulletinPress,
    closePdfViewer,
  } = useFicheSalaireState(currentDate);

  const isResponsive = useResponsive();

  return (
    <View style={styles.container}>
      {EnTete}
      {loading ? (
        <View style={styles.pdfLoading}>
          <MaterialCommunityIcons name="loading" size={48} color={stdCouleurBleu} />
          <Text style={styles.pdfLoadingText}>Chargement des bulletins...</Text>
        </View>
      ) : error ? (
        <View style={styles.pdfError}>
          <MaterialCommunityIcons name="alert-circle" size={48} color="#ef4444" />
          <Text style={styles.pdfErrorText}>{error}</Text>
        </View>
      ) : (
        <>
          {bulletinsPaie.length === 0
            ? (<InfoCentre icon="file-document" message="Aucun bulletin n'est actuellement disponible"/>)
            : !isResponsive ? (
              // Layout desktop : FlatList à gauche, PDF viewer à droite
              <View style={styles.desktopLayout}>
                <View style={styles.listSide}>
                  <FlatList
                    data={bulletinsPaie}
                    keyExtractor={(item) => item.id}
                    renderItem={({ item }) => (
                      <BulletinItem item={item} onPress={handleBulletinPress} />
                    )}
                    contentContainerStyle={styles.listContainer}
                    testID='SC_MAIN_CONTENT'
                  />
                </View>

                <View style={styles.pdfSide}>
                  {selectedBulletin?.fichierUrl ? (
                    <PdfViewer
                      source={{ uri: selectedBulletin.fichierUrl || '' }}
                      height="100%"
                      onError={(pdfError) => {
                        console.log('Erreur PdfViewer:', pdfError);
                        console.log('URL utilisée:', selectedBulletin.fichierUrl);
                      }}
                    />
                  ) : (
                    <View style={styles.pdfPlaceholder}>
                      <MaterialCommunityIcons name="file-pdf-box" size={64} color="#cbd5e1" />
                      <Text style={styles.pdfPlaceholderText}>
                        Sélectionnez un bulletin de paie pour l'afficher
                      </Text>
                    </View>
                  )}
                </View>
              </View>
            ) : (
              // Layout mobile : FlatList seule
              <FlatList
                data={bulletinsPaie}
                keyExtractor={(item) => item.id}
                renderItem={({ item }) => (
                  <BulletinItem item={item} onPress={handleBulletinPress} />
                )}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={styles.listContainer}
                testID='SC_MAIN_CONTENT'
              />
            )
          }

        {isResponsive && isWeb && (

          <Dialog
            visible={showPdfViewer}
            onClose={closePdfViewer}
            title={selectedBulletin ? `${getMonthNumber(selectedBulletin.mois)} ${selectedBulletin.annee}` : 'Bulletin de paie'}
          >
            {selectedBulletin?.fichierUrl ? (
              <PdfViewer source={{ uri: selectedBulletin.fichierUrl || '' }}/>
            ) : (
              <View style={styles.pdfError}>
                <MaterialCommunityIcons name="file-remove" size={48} color="#ef4444" />
                <Text style={styles.pdfErrorText}>Fichier PDF non disponible</Text>
              </View>
            )}
          </Dialog>
          )}

          {/* Mobile natif : PdfViewer directement (ouvre le viewer natif) */}
          {isResponsive && !isWeb && showPdfViewer && selectedBulletin?.fichierUrl && (
            <PdfViewer
              key={`pdf-${pdfKey}`}
              source={{ uri: selectedBulletin.fichierUrl || '' }}
              filename={`Bulletin_${getMonthNumber(selectedBulletin.mois)}_${selectedBulletin.annee}.pdf`}
              onError={(pdfError) => {
                console.log('Erreur PdfViewer:', pdfError);
              }}
              onFinally={closePdfViewer}
            />
          )}
        </>
      )}
    </View>
  )
}
